import CheckIcon from '@icons/check.svg?react';
import { generateKey } from '@utils';
import Styled from './OutputCard.styled';

interface Props {
  title: string;
  intro: string;
  items: string[];
}

function OutputCard({ title, intro, items }: Props) {
  return (
    <Styled.Root>
      <Styled.Title>{title}</Styled.Title>
      <Styled.Intro>{intro}</Styled.Intro>
      <Styled.List>
        {items.map((item) => (
          <Styled.Item key={generateKey(`output-item-${item}`)}>
            <Styled.IconWrapper aria-hidden>
              <CheckIcon />
            </Styled.IconWrapper>
            <Styled.ItemText>{item}</Styled.ItemText>
          </Styled.Item>
        ))}
      </Styled.List>
    </Styled.Root>
  );
}

export default OutputCard;
